import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchProductsBestSelling = createAsyncThunk(
  'productsBestSelling/fetch',
  async ({ lang, page = 1 }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${BASE_URL}/products/best-selling`, {
        params: { lang, page },
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
); 